export default __webpack_public_path__ + "static/media/aeroplane.867e87af.svg";